import { Space, Table } from 'antd';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { SerializedMeterRegister } from '@enmon/commons';
import { useLogDecoder } from '../../../hooks/api/enmon-tools/decoder/useLogDecoder';
import { DecoderTab as messages } from '../messages';

export const DecoderTab: React.VFC<{ dataSourceId: SerializedMeterRegister['dataSourceId'] }> = ({ dataSourceId }) => {
  const params = useMemo(() => ({ search: dataSourceId ?? undefined }), [dataSourceId]);
  const { data = [], isLoading } = useLogDecoder(params);
  const intl = useIntl();

  const serializedData = useMemo(() => {
    return data.map(item => ({
      channel: 'channel' in item.registerBy ? item.registerBy.channel : JSON.stringify(item.registerBy),
      date: item.measurement.date,
      value: item.measurement.value,
    }));
  }, [data]);

  return (
    <Space className="w-100" direction="vertical">
      <Table
        columns={[
          { title: intl.formatMessage(messages.channel), dataIndex: 'channel', key: 'channel' },
          {
            title: intl.formatMessage(messages.date),
            dataIndex: 'date',
            key: 'date',
            render: value => new Date(value).toLocaleString(),
          },
          { title: intl.formatMessage(messages.value), dataIndex: 'value', key: 'value' },
        ]}
        dataSource={serializedData}
        loading={isLoading}
        scroll={{ x: 800 }}
      />
    </Space>
  );
};
